import { useIsMobile } from '@stores/AppCommonData';
import usePaymentNudgeStore from '@stores/headerNudge';
import { localStorageAvailable } from '@utils/localStorage';
import { useCallback, useEffect, useState } from 'react';

const useStoreNudge = ({ showStoreTab }) => {
  const isMobile = useIsMobile();
  const [showStoreTooltip, setShowStoreTooltip] = useState(false);
  const { isPaymentNudge } = usePaymentNudgeStore();

  const checkForStoreNudge = useCallback(() => {
    if (
      !isMobile &&
      !isPaymentNudge &&
      localStorageAvailable() &&
      !localStorage.getItem('storeToolTipShown') &&
      showStoreTab
    ) {
      setShowStoreTooltip(true);
      localStorage.setItem('storeToolTipShown', 'true');
    }
  }, [isPaymentNudge, showStoreTab, isMobile]);

  useEffect(() => {
    document.addEventListener('scroll', checkForStoreNudge);
    return () => {
      document.removeEventListener('scroll', checkForStoreNudge);
    };
  }, [checkForStoreNudge]);

  return {
    showStoreTooltip
  };
};

export default useStoreNudge;
